module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-and-footer"
  }, [_c('header', [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "center",
      "background-color": "#fff",
      "position": "fixed",
      "top": "0",
      "z-index": "999"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        return _vm.toPath('index', '', 'navLogo')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "function-list"
  }, [_c('div', {
    staticClass: "function-list-item",
    class: {
      active: _vm.activeName == 'index'
    },
    on: {
      "click": function($event) {
        return _vm.toPath('index', '', 'navLogo')
      }
    }
  }, [_vm._v("\n              首页\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "function-list-item",
    class: {
      active: _vm.activeName == 'server-product'
    }
  }, [_c('span', [_vm._v("服务产品")]), _vm._v(" "), _c('div', {
    staticClass: "hover-container"
  }, [_c('div', {
    staticClass: "hover-container-item",
    staticStyle: {
      "margin-top": "0.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.watchMore('0')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "hover-container-item",
    on: {
      "click": function($event) {
        return _vm.watchMore('1')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "hover-container-item",
    on: {
      "click": function($event) {
        return _vm.watchMore('2')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "hover-container-item",
    staticStyle: {
      "margin-bottom": "1.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.watchMore('3')
      }
    }
  }, [_vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "function-list-item",
    class: {
      active: _vm.activeName == 'order'
    }
  }, [_c('span', [_vm._v("订单中心")]), _vm._v(" "), _c('div', {
    staticClass: "hover-container"
  }, [_c('div', {
    staticClass: "hover-container-item",
    staticStyle: {
      "margin-top": "0.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.toPath('order-booking')
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "hover-container-item",
    on: {
      "click": function($event) {
        return _vm.toPath('container-orders')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "hover-container-item",
    on: {
      "click": function($event) {
        return _vm.toPath('fee-confirmation')
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "hover-container-item",
    staticStyle: {
      "margin-bottom": "0.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.toPath('account-checking')
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "hover-container-item",
    staticStyle: {
      "margin-bottom": "0.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.toPath('cross-border-logistics')
      }
    }
  }, [_vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "function-list-item",
    class: {
      active: _vm.activeName == 'service-advisory'
    }
  }, [_c('span', [_vm._v("服务支持")]), _vm._v(" "), _c('div', {
    staticClass: "hover-container small"
  }, [_c('div', {
    staticClass: "hover-container-item",
    staticStyle: {
      "margin-top": "0.5rem"
    },
    on: {
      "click": _vm.consultService
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "hover-container-item",
    on: {
      "click": _vm.contactService
    }
  }, [_vm._m(10)])])]), _vm._v(" "), _c('div', {
    staticClass: "function-list-item",
    class: {
      active: _vm.activeName == 'about'
    },
    on: {
      "click": function($event) {
        return _vm.toPath('about')
      }
    }
  }, [_vm._v("\n              关于我们\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "switch-bar"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("中")]), _vm._v("   \n            "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#d3d3d3"
    },
    on: {
      "click": _vm.toEnglish
    }
  }, [_vm._v("En")])]), _vm._v(" "), (!_vm.isLogin) ? _c('div', {
    staticClass: "login-bar"
  }, [_c('span', {
    staticClass: "no-login",
    on: {
      "click": function($event) {
        return _vm.toPath('login')
      }
    }
  }, [_vm._v("登录")])]) : _c('div', {
    staticClass: "user-name"
  }, [_c('div', {
    staticClass: "login-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.user.userDisplayName))])]), _vm._v(" "), _c('div', {
    staticClass: "user-more"
  }, [_c('div', {
    staticClass: "user-more-item",
    on: {
      "click": function($event) {
        return _vm.toPath('personal-center')
      }
    }
  }, [_vm._v("\n                个人中心\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "user-more-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])])])])])]), _vm._v(" "), _vm._t("default", [_vm._v("内容")]), _vm._v(" "), _c('footer', {
    staticStyle: {
      "background": "rgb(30, 55, 64)"
    }
  }, [_c('div', {
    staticClass: "footer"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "reference"
  }, [_c('div', [_vm._v("\n          2017-" + _vm._s(_vm.nowYear) + "\n          "), _c('svg', {
    staticClass: "icon",
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "t": "1656397769079",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "10742",
      "width": "16",
      "height": "16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
      "p-id": "10743",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M517.6 351.3c53 0 89 33.8 93 83.4 0.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c0.1-87 37-135.5 102.2-135.5z",
      "p-id": "10744",
      "fill": "#fff"
    }
  })]), _vm._v(" "), (_vm.hljHost) ? _c('span', [_vm._v("黑龙江鸭嘴兽供应链管理有限公司 版权所有")]) : (_vm.tjHost) ? _c('span', [_vm._v("天津鸭嘴兽现代物流有限公司 版权所有")]) : _c('span', [_vm._v("宁波鸭嘴兽网络科技有限公司 版权所有")])]), _vm._v(" "), _c('div', [(!_vm.hljHost && !_vm.tjHost) ? _c('img', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "sub",
      "margin-right": "10px"
    },
    attrs: {
      "src": require("../images/certIcon.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.duckbillHost) ? _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "target": "_blank",
      "rel": "noreferrer",
      "href": "https://beian.mps.gov.cn/#/query/webSearch?code=33020602001564"
    }
  }, [_vm._v("浙公网安备33020602001564号")]) : _vm._e(), _vm._v(" "), (_vm.yzsHost) ? _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "target": "_blank",
      "rel": "noreferrer",
      "href": "https://beian.mps.gov.cn/#/query/webSearch?code=33020602001565"
    }
  }, [_vm._v("浙公网安备33020602001565号")]) : _vm._e(), _vm._v(" "), (_vm.devHost) ? _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "target": "_blank",
      "rel": "noreferrer",
      "href": "https://beian.mps.gov.cn/#/query/webSearch?code=33020602001565"
    }
  }, [_vm._v("浙公网安备33020602001565号")]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [(_vm.hljHost) ? _c('div', [_vm._v("黑ICP备2022009768")]) : (_vm.tjHost) ? _c('div', [_vm._v("津ICP备2023000376号")]) : _c('div', [_vm._v("浙ICP备2025180488号")])])])])]), _vm._v(" "), _c('newModal', {
    ref: "newModal",
    attrs: {
      "type": _vm.newModalInfo.type,
      "messageInfo": _vm.newModalInfo.messageInfo,
      "isConfirm": _vm.newModalInfo.isConfirm,
      "okBtnText": _vm.newModalInfo.okBtnText
    },
    on: {
      "onOk": _vm.newModalInfo.onOk
    }
  }), _vm._v(" "), (_vm.showChatPop) ? _c('chatPop', {
    ref: "chatpop",
    attrs: {
      "page": "header"
    }
  }) : _vm._e(), _vm._v(" "), _c('registerModal', {
    ref: "registerModal"
  }), _vm._v(" "), _c('Modal', {
    staticClass: "modal-no-bottom",
    attrs: {
      "width": "350"
    },
    model: {
      value: (_vm.loginModal.show),
      callback: function($$v) {
        _vm.$set(_vm.loginModal, "show", $$v)
      },
      expression: "loginModal.show"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0",
      "font-size": "22px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "alert-circled",
      "color": "#f90",
      "size": "50"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n        您还未登录，请"), _c('a', {
    on: {
      "click": function($event) {
        return _vm.toPath('register-personal')
      }
    }
  }, [_vm._v("注册")]), _vm._v("/"), _c('a', {
    on: {
      "click": function($event) {
        return _vm.toPath('login')
      }
    }
  }, [_vm._v("登录")]), _vm._v("后再操作\n      ")])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("集卡运输")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("出口报关")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("监装检验")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("数字协同")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("我的订单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("箱单查询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("费用确认")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("月结对账")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("好柜跟踪")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("服务咨询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("联系客服")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone",
    staticStyle: {
      "color": "#02cad6",
      "font-size": "16px"
    }
  }, [_c('i', {
    staticClass: "iconfont icondianhua1"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("021-36622199")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "first"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "line-height": "38px",
      "font-weight": "600",
      "margin-top": "8px"
    }
  }, [_vm._v("\n              投诉电话（24小时）\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "40px",
      "font-weight": "900"
    }
  }, [_vm._v("021-36622199")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wechat-wrapper"
  }, [_c('img', {
    attrs: {
      "src": require("../images/鸭嘴兽科技二维码.jpg")
    }
  }), _vm._v("鸭嘴兽科技\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "wechat-wrapper",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/鸭嘴兽拖卡二维码.jpg")
    }
  }), _vm._v("鸭嘴兽拖卡\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "wechat-wrapper",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/website-qrcode.jpg")
    }
  }), _vm._v("客户端小程序\n            ")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-71c01394", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71c01394"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/header-and-footer.vue
// module id = 1368
// module chunks = 61